import { Button, Grid, InputLabel, TextField } from '@mui/material';
import { Form } from 'react-bootstrap';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React from 'react';
import { Controller } from 'react-hook-form';

const transformToApiformat = keys =>
  keys.reduce((acc, { key, value }) => {
    value.forEach(v => {
      acc.push({ key, value: v });
    });
    return acc;
  }, []);

const transformToMappableFormat = keys => {
  const groupedKeywords = keys?.reduce((acc, obj) => {
    const { key, value } = obj;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(value);
    return acc;
  }, {});

  return groupedKeywords
    ? Object?.entries(groupedKeywords)?.map(([key, value]) => ({
        key,
        value,
      }))
    : [];
};

export const Keysfield = ({ control, viewFields }) => {
  const deleteKeyWord = (keys, keyTarget, word) => {
    const apiFormatKeys = transformToApiformat(keys);
    return apiFormatKeys.filter(({ key, value }) => {
      return !(key === keyTarget && value === word);
    });
  };

  const deleteKey = (keys, keyTarget) => {
    const apiFormatKeys = transformToApiformat(keys);
    return apiFormatKeys.filter(({ key }) => key !== keyTarget);
  };

  return (
    <>
      <Controller
        name="keywords"
        control={control}
        render={({ field: { onChange, value } }) => {
          const groupedArray = transformToMappableFormat(value);

          return groupedArray?.map((kword, index) => (
            <React.Fragment key={kword}>
              <Grid item xs={4} key={index}>
                <Form.Group className="mb-3" controlId="formChave">
                  <InputLabel className="form-label" htmlFor="chave">
                    Chave
                  </InputLabel>
                  <TextField
                    style={{ background: '#EFEFEF', color: '#fff' }}
                    id="video-selected-key"
                    disabled
                    value={kword.key}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                  />
                </Form.Group>
              </Grid>
              <Grid item xs={6} key={kword.key}>
                <Form.Group className="mb-3" controlId="formChave">
                  <InputLabel className="form-label" htmlFor="chave">
                    Palavra
                  </InputLabel>

                  <ul
                    className="selected-keywords"
                    key={kword.key}
                    id="video-selected-keyword">
                    {kword.value.map(val => (
                      <li
                        key={val}
                        className={`${
                          viewFields
                            ? 'selected-keywords-item disabled-menu'
                            : 'selected-keywords-item '
                        }`}
                        onClick={() =>
                          onChange(deleteKeyWord(groupedArray, kword.key, val))
                        }>
                        {val}
                        <CloseOutlinedIcon
                          style={{ cursor: 'pointer' }}
                          fontSize="small"
                        />
                      </li>
                    ))}
                  </ul>
                </Form.Group>
              </Grid>
              <Grid item xs={2} key={index + '-' + kword}>
                <Button
                  disabled={viewFields}
                  id="video-remove-keyword-button"
                  color="error"
                  style={{
                    textTransform: 'capitalize',
                    color: 'rgba(255, 98, 98, 1)',
                  }}
                  startIcon={<NotInterestedOutlinedIcon />}
                  onClick={() => onChange(deleteKey(groupedArray, kword.key))}>
                  Remover
                </Button>
              </Grid>
            </React.Fragment>
          ));
        }}
      />
    </>
  );
};
